import {
    AggregateFunctions,
    AggregateQueryInterval,
    ApiQuery,
    SortDirections,
} from "~/modules/filters/types";
import { TokenTimeseriesColumns, TokenTimeseriesGroupBy } from "./types";
import { API_QUERY_EXAMPLES } from "./components/TokenTimeseriesList/consts";

// // // //

/**
 * DEFAULT_TOKEN_TIMESERIES_QUERY
 * Default ApiQuery for TokenTimeseries API
 */
export const DEFAULT_TOKEN_TIMESERIES_QUERY: ApiQuery = {
    filter: API_QUERY_EXAMPLES[0].query.filter,
    aggregate: {
        groupBy: TokenTimeseriesGroupBy.protocol,
        aggregateFunction: AggregateFunctions.Sum,
        interval: AggregateQueryInterval.day,
    },
    sort: {
        direction: SortDirections.asc,
        field: TokenTimeseriesColumns.date,
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};

// const todaysDate = new Date();
// todaysDate.setDate(todaysDate.getDate() - 1);
// const yesterdayDateString = todaysDate.toISOString();
// export const TOKEN_TIMESERIES_YESTERDAY_FILTER: Filter = {
//     field: TokenTimeseriesColumns.date,
//     operator: FilterOperators.Before,
//     value: yesterdayDateString,
// };

// Map of `TokenTimeseriesGroupBy` values to human-readable labels
export const TOKEN_TIMESERIES_GROUP_BY_LABELS: Record<
    TokenTimeseriesGroupBy,
    string
> = {
    [TokenTimeseriesGroupBy.protocol]: "Platform",
    [TokenTimeseriesGroupBy.issuer]: "Issuer",
    [TokenTimeseriesGroupBy.network]: "Network",
    [TokenTimeseriesGroupBy.assetClass]: "Asset Class",
    [TokenTimeseriesGroupBy.asset]: "Asset",
    [TokenTimeseriesGroupBy.assetTicker]: "Asset Ticker",
    [TokenTimeseriesGroupBy.assetType]: "Asset Type",
    [TokenTimeseriesGroupBy.token]: "Token",
    [TokenTimeseriesGroupBy.measure]: "Measure",
    [TokenTimeseriesGroupBy.manager]: "Manager",
    [TokenTimeseriesGroupBy.peggedAsset]: "Pegged Asset",
    [TokenTimeseriesGroupBy.peggedAssetType]: "Pegged Asset Type",
    [TokenTimeseriesGroupBy.jurisdictionCountry]: "Jurisdiction Country",
    [TokenTimeseriesGroupBy.auditor]: "Auditor",
    [TokenTimeseriesGroupBy.baseProtocol]: "Base Platform",
    [TokenTimeseriesGroupBy.cryptoBroker]: "Crypto Broker",
    [TokenTimeseriesGroupBy.cryptoCustodian]: "Crypto Custodian",
    [TokenTimeseriesGroupBy.fundAdministrator]: "Fund Administrator",
    [TokenTimeseriesGroupBy.payingAgent]: "Paying Agent",
    [TokenTimeseriesGroupBy.subAdvisor]: "Sub Advisor",
    [TokenTimeseriesGroupBy.traditionalBroker]: "Traditional Broker",
    [TokenTimeseriesGroupBy.transferAgent]: "Transfer Agent",
    [TokenTimeseriesGroupBy.exchangeAgent]: "Exchange Agent",
    [TokenTimeseriesGroupBy.traditionalCustodian]: "Traditional Custodian",
    [TokenTimeseriesGroupBy.parentNetwork]: "Parent Network",
    [TokenTimeseriesGroupBy.realEstateCountry]: "Real Estate Country",
};
